module.exports = __webpack_public_path__ + "img/google.75f83c9f.svg";